import * as React from "react";
import PropTypes from 'prop-types';

const SvgSuccessCheckGreen = props => {
  if (props.id !== "_svgsuccesscheckgreen") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 40 40" {...props}><path fill="#2a7952" d="M16.59 21.57L30.229 7.583l4.545 4.662-18.182 18.649L5.227 19.238l4.545-4.662z" /></svg>;
};

SvgSuccessCheckGreen.displayName = "_svgsuccesscheckgreen";
SvgSuccessCheckGreen.propTypes = {
  id: PropTypes.string
};
SvgSuccessCheckGreen.defaultProps = {
  id: ''
};
export default SvgSuccessCheckGreen;